import request from "@/modules/request";
import querystring from "query-string";

export default class ProductService {
  constructor() {}

  async getProducts(query, pagination) {
    const q = querystring.stringify({ ...query, ...pagination });
    return request
      .callInternal({
        method: "get",
        route: `/api/products?${q}`,
      })
      .then((results) => {
        return results;
      })
      .catch((error) => {
        console.error(error);
        throw error;
      });
  }
}
